import axios from "axios";

export const API = "/api";

// The session lives in an httpOnly cookie the browser sends on its own; the custom
// header is the backend's CSRF check (cross-site pages can't set it).
const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-DevPath-Client": "web" },
});

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
